module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [(_vm.user) ? _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(!_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Usuarios por activar",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/contacts",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fas fa-user-plus"
  }), _vm._v(" "), (_vm.newContacts.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.newContacts.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Mensajes nuevos",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/allComments",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), (_vm.receivedNew.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.receivedNew.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Pagos",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": {
        'name': 'Búsqueda',
        params: {
          statusId: ['6']
        }
      },
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets"
  }), _vm._v(" "), (_vm.newPayments.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.newPayments.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Mensajes nuevos",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/allComments",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" "), (_vm.providerNewMessages.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.providerNewMessages.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Invitaciones a compulsas",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/compulsas",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), (_vm.newCompulsas.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.newCompulsas.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "dashUsername"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('small', [_vm._v(" Puesto: " + _vm._s(_vm.user.job.job))]), _vm._v(" "), _c('small', [_vm._v(" " + _vm._s(_vm.user.email))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [(_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out-alt text-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "page",
    staticStyle: {
      "color": "var(--primary-color)"
    }
  }, [_vm._v("Cerrar Sesión")])])])]) : _vm._e()], 1)])])], 1)]) : _vm._e()])]), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.$route.name.toUpperCase()) + "\n          "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "data-cy": "home"
    }
  }), _vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Cargando información, aguarde un momento"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer text-center"
  }, [(_vm.entorno) ? _c('div', {
    staticClass: "entorno"
  }, [_vm._v(_vm._s(_vm.entorno))]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n        "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }), _vm._v(".")]), _vm._v(" powered by PowerSuppliers.io\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {}, [_c('div', {
    staticClass: "logo-mini gradiente"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "left-block logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "PowerSuppliers"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74158a71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 643
// module chunks = 1